export enum ConsentNameType {
    NocowanieTouristGDPR = 'nocowanieTouristGDPR',
    SzallasTouristGDPR = 'szallasTouristGDPR',
    Mailing = 'mailing',
    Profiling = 'profiling',
}

export interface ConsentDataModel {
    id: ConsentNameType;
    isRequired: boolean;
    excerptTranslationKey: string;
    expandedTextTranslationKey?: string;
    validationMessage?: string;
    /**
     * If true, this checkbox controls SalesManago emailOptIn consent.
     * When checked, emailOptIn=1 will be sent to SalesManago.
     */
    smEmailOptIn?: boolean;
}
